<!--保留-->
<template>
  <div class="notice-comp" v-show="show">
        <span class="close" @click="close()">
            <img src="~@/assets/close.svg" alt/>
        </span>
    <h3>关于官网维护无法正常访问的公告</h3>
    <h6>尊敬的热璞数据库用户：</h6>
    <p>因5月25日周一上午8：00 ——5月26日周二20:00 将对热璞数据库官网进行升级维护，届时会影响广大用户对官网的正常访问，为此给您带来的不便表示歉意。 同时，我们会加快维护进度，让您可以尽快访问，也请您随时关注我们的官网动态。</p>
  </div>
</template>

<script>
export default {
  name: "Notice",
  data() {
    return {
      show: false
    }
  },
  created() {
    var show = sessionStorage.getItem('notice_comp_show')
    if(!show) {
      this.show = true
    }
  },
  methods: {
    close() {
      sessionStorage.setItem('notice_comp_show', true)
      this.show = false
    }
  }
}
</script>

<style>
.notice-comp {
  position: fixed !important;
  left: 30%;
  right: 30%;
  top: 20%;
  z-index: 99999999999999999999999999;
  background: #00aef3;
  color: #fff;
  padding: 50px 100px;
  border-radius: 10px;
}
.notice-comp .close img {
  position: absolute;
  right: 30px;
  width: 40px;
  cursor: pointer;
  margin-top: -10px;
}
.notice-comp h3 {
  font-size: 24px;
}
.notice-comp h6 {
  font-size: 16px;
  margin-top: 20px;
}
.notice-comp p {
  font-size: 16px;
  margin-top: 10px;
  line-height: 1.6;
}
#newBridge {
  z-index: 99999 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Notice.vue